import React from 'react';

import { QuestionWrapper } from './styles';

function Question() {
    return(
        <QuestionWrapper>
            <h1>Have questions in mind?</h1>
            <p>Let us help you.</p>
            <div>
                <input type="email" placeholder="Email Address"/>
                <button>Subscribe Now</button>
            </div>
            <h6>We promise not to spam you.</h6>
        </QuestionWrapper>
    )
}

export default Question;